import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetScholarshipTypesQuery } from "../../hooks/useGetScholarshipTypesQuery";
import { key_ScholarshipTypes } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { ScholarshipTypeType } from "../../types/ScholarshipType";
import { updateScholarshipType } from "../../services/school/scholarshipTypetype";
import { setScholarshipTypeData } from "../../redux/slices/school/scholarshipType";

const columnNamesMap: { [key: string]: string } = {
    description: "Nome",
};

export const ScholarshipTypes = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemToBeDeleted, setItemToBeDeleted] = useState<ScholarshipTypeType | null>(null);

    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();
    const { data, status } = useGetScholarshipTypesQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateScholarshipType, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_ScholarshipTypes);
            toast.success("Tipo de Bolsa removido!");
        },
        onError: () => {
            toast.error("Erro ao apagar Tipo de Bolsa.");
        }
    });

    const handleCreate = () => {
        navigate(routes.createScholarshipType);
    };

    const handleEdit = (k: ScholarshipTypeType) => {
        dispatch(setScholarshipTypeData(k));
        navigate(routes.updateScholarshipType);
    };

    const handleDelete = (k: ScholarshipTypeType) => {
        k.status = false;
        mutationUpdate.mutateAsync(k);
    };

    const openDeleteDialog = (s: ScholarshipTypeType) => {
        setItemToBeDeleted(s);
    };

    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted);
        }
    };

    const options = data?.items.map((item) => [
        {
            label: "Editar",
            onClick: () => handleEdit(item),
            icon: <Pencil1Icon />
        },
        {
            label: "Excluir",
            onClick: () => openDeleteDialog(item),
            icon: <TrashIcon />
        },
    ]) || [];

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <Lists
                status={status}
                TableComponent={() => (
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                )}
                handleClickCreate={handleCreate}
            />
            <ConfirmAlertDialog
                open={!!itemToBeDeleted}
                onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                title="Esta operação é irreversível"
                item={itemToBeDeleted}
                onConfirm={confirmDelete}
                onCancel={() => setItemToBeDeleted(null)}
            />
        </>
    );
};
